import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
  maxItems: 12,

  input: '',
  selectedKeywords: [],

  isFetching: false,
  isFetched: false,
  fetchError: null,
  keywords: [],
};

export default {
  namespaced: true,

  state,
  mutations,
  actions,
  getters,
};
